import type { IMenuDivider } from "./types";
import { clsx } from "clsx";

type IProps = {
  item: IMenuDivider;
};

export const MenuDivider = ({ item }: IProps) => {
  return (
    <div
      className={clsx("nuco-menu__divider", item.className)}
      role="separator"
    />
  );
};
